import { Page, PageHeader } from 'components';
import { Box, Dialog, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { EventsFilter, EventsTable } from './components';
import EventDetails from './components/EventDetails';
import { useLocation } from 'react-router-dom';
import { ToggleButton } from '@mui/material';
import { SearchFilter } from 'components/Events';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    minHeight: '100%',
    flex: 1,
  },
  eventfilter: {
    width: '100%',
  },
  header: {
    marginBottom: theme.spacing(2),
  },
}));

const EventsPageMobile = () => {
  const classes = useStyles();
  const [activeEvent, setSelectedEvent] = useState({});
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const location = useLocation();
  // If we're redirected here, we can use the redirectData to set the filters
  const [redirectData] = useState(location.state?.redirectData ? location.state?.redirectData : undefined);

  if (redirectData) {
    location.state.redirectData = undefined;
  }
  const [redirectEvents, setRedirectEvents] = useState(!!redirectData);

  const [showDetails, setShowDetails] = useState(false);
  const [selectedId, setSelectedId] = useState('');

  const handleHide = () => {
    setSelectedEvent({});
    setSelectedId('');
    setShowDetails(false);
  };

  const toggleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  return (
    <Page>
      <PageHeader title="events" className={classes.header}></PageHeader>
      <Grid container direction="row" spacing={2}>
        <Grid container item lg={10} xl={10} direction="row" spacing={2}>
          <Grid item xs={9} sm={9} lg={11} xl={11}>
            <SearchFilter />
          </Grid>
          <Grid item xs={1} sm={1} lg={1} xl={1}>
            <ToggleButton onClick={toggleFilter} value="check">
              Filter
            </ToggleButton>
          </Grid>
          <Grid item xs={12} sm={12} lg={12} xl={12}>
            <EventsTable
              redirectData={{ redirectData: redirectData, redirectEvents: redirectEvents }}
              setSelectedEvent={setSelectedEvent}
              selectedEvent={activeEvent}
              setShowDetails={setShowDetails}
              selectedId={selectedId}
              setSelectedId={setSelectedId}
            />
          </Grid>
        </Grid>
        <Grid item container lg={2} xl={2}>
          <EventsFilter setRedirectEvents={setRedirectEvents} isOpen={filterIsOpen} toggleFilter={toggleFilter} />
        </Grid>
      </Grid>
      <Dialog
        disableEnforceFocus
        style={{ pointerEvents: 'none' }}
        PaperProps={{ style: { pointerEvents: 'auto' } }}
        open={showDetails}
        hideBackdrop
        onClose={() => {}}
      >
        <Box>
          {!!showDetails && (
            <EventDetails setSelectedId={setSelectedId} selectedEvent={activeEvent} hide={() => handleHide()} />
          )}
        </Box>
      </Dialog>
    </Page>
  );
};

export default EventsPageMobile;
